<template>
    <div @click="state.isOpen = true" class="cursor-pointer" v-bind="$attrs">
        <slot></slot>
    </div>
    <MiniModalCustom
        :is-open="state.isOpen"
        @close="onClose"
        title="Create Group"
    >
        <div class="my-4">
            <label for="name" class="block font-semibold my-2 text-sm">
                Name
            </label>
            <app-input
                name="Name"
                placeholder="Group Name"
                v-model="state.name"
            ></app-input>
        </div>

        <div class="my-4">
            <label for="name" class="block font-semibold my-2 text-sm">
                Image
            </label>
            <ImageUpload
                name="image"
                default="/default-images/team.png"
                @updated="state.image = $event"
            ></ImageUpload>
        </div>

        <div class="my-4">
            <label for="name" class="block font-semibold my-2 text-sm">
                Chat Style
            </label>
            <ColorPicker
                format="rgb"
                shape="circle"
                use-type="pure"
                picker-type="chrome"
                v-model:pureColor="state.primaryColor"
            />

            <ColorPicker
                format="rgb"
                shape="circle"
                use-type="pure"
                picker-type="chrome"
                v-model:pureColor="state.secondaryColor"
            />
        </div>
        <div class="flex mt-8 justify-end gap-2">
            <button
                type="button"
                class="
                    flex
                    py-2
                    px-6
                    border
                    font-bold
                    border-accent
                    rounded-full
                    text-accent
                    items-center
                "
                @click="onClose"
            >
                Cancel
            </button>
            <button
                type="button"
                @click="save"
                class="
                    py-2
                    px-6
                    bg-primary
                    font-bold
                    rounded-full
                    text-white
                    items-center
                "
            >
                Save
            </button>
        </div>
    </MiniModalCustom>
</template>

<script setup>
import { defineProps, reactive, onMounted } from "vue";
import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";
import emitter from "tiny-emitter/instance";

const props = defineProps([]);

const state = reactive({
    isOpen: false,
    // form
    primaryColor: "#2180F3",
    secondaryColor: "#4E20F3",
});

async function save() {
    const frame = document.getElementById("chat-window");

    const form = new FormData();
    form.append("name", state.name);
    form.append("primary_color", state.primaryColor);
    form.append("secondary_color", state.secondaryColor);
    if (state.image) {
        form.append("group_image", state.image);
    }

    try {
        const resp = await axios.post("/chat/group/createApi", form);
        frame.contentWindow.location = resp.data.url;
        emitter.emit("open-group-members", resp.data.group_id);
    } catch (e) {
        console.error(e);
    }

    onClose();
}

function onClose() {
    state.isOpen = false;
    state.name = "";
    state.primaryColor = "#2180F3";
    state.secondaryColor = "#4E20F3";
    state.image = null;
}
onMounted(() => {
    window.addEventListener("message", function (event) {
        const action = event.data.action;
        if (action === "create_group_chat") {
            state.isOpen = true;
        }
    });
});
</script>
